import YouTube from 'react-youtube';
import { getVideoIdFromURL } from '~/util';

export const VideoPlayer = ({ videoUrl }: { videoUrl: string }) => {
    const { provider, id, start } = getVideoIdFromURL(videoUrl);

    switch (provider) {
        case 'Youtube':
            return (
                <YouTube
                    videoId={id ?? ''}
                    className="relative w-full aspect-video h-full overflow-hidden rounded-2xl"
                    iframeClassName="w-full h-full"
                    opts={{
                        width: '100%',
                        height: '100%',
                        playerVars: {
                            rel: 0,
                            start: start ? parseInt(start) : undefined,
                        },
                    }}
                />
            );
        case 'Medal':
            return (
                <iframe
                    title="Medal.tv Video Player"
                    src={`https://medal.tv/clip/${id}?autoplay=0&loop=0&controls=1&muted=0&start=${start ?? 0}`}
                    className="relative w-full aspect-video h-full overflow-hidden rounded-2xl focus:outline-none"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen
                />
            );
        case 'Twitch':
            if (!id) return null;
            if (/^\d+$/.test(id)) {
                return (
                    <iframe
                        title="Twitch Video Player"
                        src={`https://player.twitch.tv/?video=${id}&parent=${typeof window === 'undefined' ? 'localhost' : window.location.hostname}`}
                        className="relative w-full aspect-video h-full overflow-hidden rounded-2xl focus:outline-none"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                    />
                );
            }

            return (
                <iframe
                    title="Twitch Clip Player"
                    src={`https://clips.twitch.tv/embed?clip=${id}&parent=${typeof window === 'undefined' ? 'localhost' : window.location.hostname}`}
                    className="relative w-full aspect-video h-full overflow-hidden rounded-2xl focus:outline-none"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen
                />
            );
        default:
            return (
                <div className="w-full aspect-video h-full flex items-center justify-center bg-background rounded-2xl">
                    <p className="text-secondary-foreground">
                        Unsupported video provider
                    </p>
                </div>
            );
    }
};
